import React from "react";
import AdminSettings from "../../Components/Admin/AdminSettings";
import SideBar from "../../Components/Admin/SideBar";

const AdminSettingsPage = () => {
    return (

        <AdminSettings />

    );
};
export default AdminSettingsPage;
